import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { MEMBERSHIP_ROLES, type Invitation, ALLOWED_VALIDATION } from 'src/features/userManagement/types';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { validationMessagesMap } from 'src/utils/messages';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/invitations/';

type FormSchemaValues = z.infer<typeof formSchema>;
const formSchema = z.object({
    email: z.string().email({ message: validationMessagesMap.validationErrorEmail }),
    role: z.nativeEnum(MEMBERSHIP_ROLES),
    validator_allowed_validation: z
        .union([z.nativeEnum(ALLOWED_VALIDATION), z.literal(null)])
        .optional()
        .default(null),
    validator_allowed_pricing_plan: z
        .union([z.string(), z.literal(null)])
        .optional()
        .default(''),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<Invitation> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

// Simply generate a new invitaiton based on the provided email
interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as CREATE_INVITATION_RESOURCE,
    useMutationHook as useCreateInvitation,
    formSchema as createInvitationFormSchema,
};
export type { DTO as CreateInvitationDTO, FormSchemaValues as CreateInvitationFormSchemaValues };
